<template>
    <div>
        <div v-for="(item,i) in dataSource" :key="i">
            <div style="color: #ff6b68">
                -- --------------------------------------
            </div>
            <div style="color: #7e7f7e">
                # 0002 2021-07-24 18:06:02.477 DEBUG 33128 --- [o-33350-exec-10] c.c.p.p.m.P.listByPage : ==>
            </div>
            <div v-if="!item.enabled">
                {{ item.keyword }} &nbsp;<span v-for="(word,wi) in getWords()" :key="wi">{{ word }} &nbsp;</span><br>
                <span v-for="(word,wi) in getWords()" :key="wi+word">{{ word }} &nbsp;</span><br>
                <span v-for="(word,wi) in getWords()" :key="wi+word">{{ word }} &nbsp;</span><br>
            </div>
            <div v-else :style="{'background':item.bg,'color':item.fg}">
                {{ item.keyword }} &nbsp;<span v-for="(word,wi) in getWords()" :key="wi">{{ word }} &nbsp;</span><br>
                <span v-for="(word,wi) in getWords()" :key="wi+word">{{ word }} &nbsp;</span><br>
                <span v-for="(word,wi) in getWords()" :key="wi+word">{{ word }} &nbsp;</span><br>
            </div>
        </div>
    </div>
</template>

<script>
var randomWords = require('random-words');
export default {
    name: "SqlPreview",
    props: {
        dataSource: {
            type: Array
        },
        defaultColor: {
            type: String
        }
    },
    methods: {
        getWords() {
            return randomWords(Math.round(Math.random() * 10) + 1)
        }
    }
}
</script>

<style scoped>

</style>
